//Begin Specialty List ; with license plate codes and additional fees to issue plate//
//F.S. 320.08056 and 320.08058
//--- Environmental / Wildlife //(count 23)
var ANR = "Animal Friend,ANR,ANP,$30";
var QCR = "Aquaculture,QCR,QCP,$30";
var CER = "Protect Our Oceans,CER,CLP,$30"; //formerly Catch Me; Release Me
var CWR = "Conserve Wildlife,CWR,CWP,$30";
var DFR = "Discover Florida Oceans,DFR,DFP,$30";
var ERR = "Everglades River of Grass,ERR,ERP,$25";
var FVR = "Fish Florida,FVR,FVP,$27";
var INR = "Indian River Lagoon,INR,INP,$20";
var LBR = "Largemouth Bass,LBR,LBP,$30";
var PAR = "Protect the Panther,PAR,PAP,$30";
var PFR = "Protect Florida Springs,PFR,PFP,$30";
var WHR = "Protect Florida Whales,WHR,WHP,$30";
var POR = "Protect Our Reefs,POR,POP,$30";
var PWR = "Protect Wild Dolphins,PWR,PWP,$25";
var SZR = "Save Our Seas,SZR,SZP,$30";
var MTR = "Save the Manatee,MTR,MTP,$30";
var FBR = "Florida Biodiversity - Save Wild Florida,FBR,FBP,$30";
var STR = "Sea Turtle,STR,STP,$28";
var SNR = "Wildlife Foundation of Florida,SNR,SNP,$30"; //formerly Sportsmen's Trust,
var FFR = "State Wildflower,FFR,FFP,$20";
var TAR = "Tampa Bay Estuary,TAR,TAP,$20";
var TCR = "Trees are Cool,TCR,TCP,$30";
//--- Special Interest / Community //(count 24)
var AER = "Agricultural Education,AER,AEP,$30";
var AGR = "Agriculture,AGR,AGP,$25";
var CLR = "Challenger Columbia,CLR,CLP,$30";
var ESR = "Endless Summer,ESR,ESP,$30";
var ARR = "Florida Arts, ARR,ARP,$25";
var HFR = "Florida Horse Park (Discover Florida's Horses),HFR,HFP,$30";
var FYR = "Florida Sheriffs Youth Ranches,FYR,FYP,$30";
var TNR = "Florida Tennis,TNR,TNP,$30";
var ORR = "Fraternal Order of Police,ORR,ORP,$30";
var FQR = "Free Masonry,FQR,FQP,$30";
var GOR = "Golf Capital,GOR,GOP,$30";
var HAR = "Homeownership,HAR,HAP,$30";
var HRR = "Horse Country,HRR,HRP,$30";
var IMR = "Imagine,IMR,IMP,$30"; //(Florida Food Bank)
var IGR = "In God We Trust,IGR,IGP,$30";
var LHR = "Lighthouse Association - Visit our Lights,LHR,LHP,$30";
var LDR = "Live the Dream,LDR,LDP,$30";
var AHR = "Police Athletic League,AHR,AHP,$25";
var SAR = "Share the Road,SAR,SAP, $20";
var SPR = "Special Olympics,SPR,SPP,$20";
var EDR = "Support Education,EDR,EDP,$25";
var SYR = "Support Soccer,SYR,SYP,$30";
var SOR = "US Olympic,SOR,SOP,$20";
//--- Special Interest / Health //(count 8)
var RXR = "American Red Cross,RXR,RXP,$30";
var CSR = "Choose Life,CSR,CSP,$25";
var DOR = "Donate Organs,DOR,DOP,$30";
var CRR = "End Breast Cancer,CRR,CRP,$30";
var HOR = "Hospice,HOR,HOP,$30";
var MJR = "Moffitt Cancer Center,MJR,MJP,$25";
var VIR = "State of Vision,VIR,VIP,$30";
var SDR = "Stop Heart Disease,SDR,SDP,$30";
var ASR = "Support Autism Programs,ASR,ASP,$30";
//--- Special Interest / Family / Kids  // (count 9)
var SCR = "Boy Scouts,SCR,SCP,$25";
var CAR = "Stop Child Abuse, CAR,CAP,$30";
var FJR = "Family First,FJR,FJP,$30";
var FUR = "Family Values,FUR,FUP,$30";
var CHR = "Invest in Children,CHR,CHP,$25";
var KKR = "Keep Kids Drug Free,KKR,KKP,$30";
var KDR = "Kids deserve Justice,KDR,KDP,$30";
var LKR = "Lauren's Kids,LKR,LKP,$30"
var PMR = "Parents make a Difference,PMR,PMP,$30";
//--- Military (American Heroes) // (count 11)
var AFR = "US Air Force,AFR,AFP,$20";
var AYR = "US Army,AYR,AYP,$20";
var GUR = "US Coast Guard,GUR,GUP,$20";
var UAR = "US Marine Corps,UAR,UAP,$20";
var NAR = "US Navy,NAR,NAP,$20";
var UPR = "US Paratrooper,UPR,UPP,$25";
var TSR = "Support our Troops,TSR,TSP,$30";
var PBR = "Support Law Enforcement,PBR,PBP,$25";
var OFR = "Fallen Law Enforcement Officers,OFR,OFP,$25";
var SFR = "Salutes Firefighters,SFR,SFP,$25";
var WER = "United We Stand,WER,WEP,$30";
var VTR = "Florida Salutes Veterans,VTR,VTP,$20";
//--- Professional Sports //(count 10)
var MAR = "Florida Marlins,MAR,MAP,$30";
var PTR = "Florida Panthers,PTR,PTP,$30";
var JJR = "Jacksonville Jaguars,JJR,JJP,$30";
var MDR = "Miami Dolphins,MDR,MDP,$30";
var MHR = "Miami Heat,MHR,MHP,$30";
var OMR = "Orlando Magic,OMR,OMP,$30";
var BBR = "Tampa Bay Bucs,BBR,BBP,$30";
var DRR = "Tampa Bay Rays,DRR,DRP,$30";
var TBR = "Tampa Bay Lightning,TBR,TBP,$30";
var NZR = "NASCAR,NZR,NZP,$30";
//--- Collegiate //(count 36)
var BYR = "Barry University,BYR,BYP,$30";
var BCR = "Bethune-Cookman,BCR,BCP,$30";
var CCR = "Clearwater Christian College,CCR,CCP,$30";
var ECR = "Eckerd College,ECR,ECP,$30";
var EWR = "Edward Waters College,EWR,EWP,$30";
var EAR = "Embry-Riddle,EAR,EAP,$30";
var FXR = "Flagler College,FXR,FXP,$30";
var FMR = "Florida A&M,FMR,FMP,$30";
var FAR = "Florida Atlantic,FAR,FAP,$30";
var FRR = "Florida College,FRR,FRP,$30";
var FGR = "Florida Gulf Coast,FGR,FGP,$30";
var FHR = "Florida Hospital University,FHR,FHP,$30";
var FTR = "Florida Institute of Technology,FTR,FTP,$30";
var FIR = "Florida International University,FIR,FIP,$30";
var FER = "Florida Memorial,FER,FEP,$30,";
var FZR = "Florida Southern,FZR,FZP,$30";
var FSR = "Florida State University,FSR,FSP,$30";
var JUR = "Jacksonville University,JUR,JUP,$30";
//var KUR = "Keiser University,KUR,KUP,$25";
var LUR = "Lynn University,LUR,LUP,$30";
var NWR = "New College,NWR,NWP,$30";
var NSR = "Nova Southeastern University,NSR,NSP,$30";
var PUR = "Palm Beach Atlantic University,PUR,PUP,$30";
var RAR = "Ringling School,RAR,RAP,$30";
var RLR = "Rollins College,RLR,RLP,$30";
var SLR = "Saint Leo University,SLR,SLP,$30";
var SXR = "Saint Thomas University,SXR,SXP,$30";
var SER = "Southeastern University,SER,SEP,$30";
var SUR = "Stetson University,SUR,SUP,$30";
var UCR = "University of Central Florida,UCR,UCP,$30";
var UFR = "University of Florida,UFR,UFP,$30";
var UMR = "University of Miami,UMR,UMP,$30";
var UNR = "University of North Florida,UNR,UNP,$30";
var USR = "University of South Florida,USR,USP,$30";
var UTR = "University of Tampa,UTR,UTP,$30";
var UWR = "University of West Florida,UWR,UWP,$30";
var WSR = "Warner Southern,WSR,WSP,$30";

//--- Motorcyle  // (count 2)
var MYR = "Motorcycle Specialty,MYR,MYP,$22";
var MUR = "Motorcycle Underage,MUR MUP,$22";

// No longer issued
//var SBR Superbowl no longer issued 12/31/92
//var GSR Girl Scouts no longer issued 1/15/02
//var QUR Quincentennial no longer issued 12/31/93
//var MOR Miami Hooters no longer issued 12/31/97
//var OPR Orlando Predators no longer issued 1/15/02
//var BSR Tampa Bay Storm no longer issued 1/15/02
//var CFR Corrections Foundation no longer issued 12/01/09

// Presale Only
// var SJR = "PRESALE ONLY - St.John's River,SJR,SJP,$30"; // PRESALE ONLY --
// var HVR = "PRESALE ONLY - Hispanic Achievers,HVR,HVP,$30"; // PRESALE ONLY --

// total 126 plates
// need 128
// END Specialty List

//note fees shown adjusted for additional fees,but calculation uses old fee schedule codes

const specialityPlates = [{
    cName: "Environmental / Wildlife",
    oSubMenu: [{
            cName: "" + ANR + "",
            cReturn: "" + ANR + "|27.00"
        },
        {
            cName: "" + QCR + "",
            cReturn: "" + QCR + "|27.00"
        },
        {
            cName: "" + CER + "",
            cReturn: "" + CER + "|27.00"
        },
        {
            cName: "" + CWR + "",
            cReturn: "" + CWR + "|27.00"
        },
        {
            cName: "" + DFR + "",
            cReturn: "" + DFR + "|27.00"
        },
        {
            cName: "" + ERR + "",
            cReturn: "" + ERR + "|22.00"
        },
        {
            cName: "" + FVR + "",
            cReturn: "" + FVR + "|24.00"
        },
        {
            cName: "" + INR + "",
            cReturn: "" + INR + "|17.00"
        },
        {
            cName: "-"
        },
        {
            cName: "" + LBR + "",
            cReturn: "" + LBR + "|27.00"
        },
        {
            cName: "" + PAR + "",
            cReturn: "" + PAR + "|27.00"
        },
        {
            cName: "" + PFR + "",
            cReturn: "" + PFR + "|27.00"
        },
        {
            cName: "" + WHR + "",
            cReturn: "" + WHR + "|27.00"
        },
        {
            cName: "" + POR + "",
            cReturn: "" + POR + "|27.00"
        },
        {
            cName: "" + PWR + "",
            cReturn: "" + PWR + "|22.00"
        },
        {
            cName: "" + SZR + "",
            cReturn: "" + SZR + "|27.00"
        },
        {
            cName: "" + MTR + "",
            cReturn: "" + MTR + "|27.00"
        },
        {
            cName: "-"
        },
        //{cName:""+SJR+"",bEnabled: false,cReturn:""+SJR+"|"},
        {
            cName: "" + FBR + "",
            cReturn: "" + FBR + "|27.00"
        },
        {
            cName: "" + STR + "",
            cReturn: "" + STR + "|25.00"
        },
        {
            cName: "" + SNR + "",
            cReturn: "" + SNR + "|27.00"
        },
        {
            cName: "" + FFR + "",
            cReturn: "" + FFR + "|17.00"
        },
        {
            cName: "" + TAR + "",
            cReturn: "" + TAR + "|17.00"
        },
        {
            cName: "" + TCR + "",
            cReturn: "" + TCR + "|27.00"
        }
    ]
    //(count 23)
}, {
    cName: "Community Interest",
    oSubMenu: [{
            cName: "" + AER + "",
            cReturn: "" + AER + "|27.00"
        },
        {
            cName: "" + AGR + "",
            cReturn: "" + AGR + "|22.00"
        },
        {
            cName: "" + CLR + "",
            cReturn: "" + CLR + "|27.00"
        },
        {
            cName: "" + ESR + "",
            cReturn: "" + ESR + "|27.00"
        },
        {
            cName: "" + ARR + "",
            cReturn: "" + ARR + "|22.00"
        },
        {
            cName: "" + HFR + "",
            cReturn: "" + HFR + "|27.00"
        },
        {
            cName: "" + FYR + "",
            cReturn: "" + FYR + "|27.00"
        },
        {
            cName: "-"
        },
        {
            cName: "" + TNR + "",
            cReturn: "" + TNR + "|27.00"
        },
        {
            cName: "" + ORR + "",
            cReturn: "" + ORR + "|27.00"
        },
        {
            cName: "" + FQR + "",
            cReturn: "" + FQR + "|27.00"
        },
        {
            cName: "" + GOR + "",
            cReturn: "" + GOR + "|27.00"
        },
        //{cName:""+HVR+"",bEnabled: false,cReturn:""+HVR+"|"},
        {
            cName: "" + HAR + "",
            cReturn: "" + HAR + "|27.00"
        },
        {
            cName: "" + HRR + "",
            cReturn: "" + HRR + "|27.00"
        },
        {
            cName: "" + IMR + "",
            cReturn: "" + IMR + "|27.00"
        },
        {
            cName: "" + IGR + "",
            cReturn: "" + IGR + "|27.00"
        },
        {
            cName: "-"
        },
        {
            cName: "" + LHR + "",
            cReturn: "" + LHR + "|27.00"
        },
        {
            cName: "" + LDR + "",
            cReturn: "" + LDR + "|27.00"
        },
        {
            cName: "" + AHR + "",
            cReturn: "" + AHR + "|22.00"
        },
        {
            cName: "" + SAR + "",
            cReturn: "" + SAR + "|17.00"
        },
        {
            cName: "" + SPR + "",
            cReturn: "" + SPR + "|17.00"
        },
        {
            cName: "" + EDR + "",
            cReturn: "" + EDR + "|22.00"
        },
        {
            cName: "" + SYR + "",
            cReturn: "" + SYR + "|27.00"
        },
        {
            cName: "" + SOR + "",
            cReturn: "" + SOR + "|17.00"
        }
    ]
    //(count 24)
}, {
    cName: "Health Interest",
    oSubMenu: [{
            cName: "" + RXR + "",
            cReturn: "" + RXR + "|27.00"
        },
        {
            cName: "" + CSR + "",
            cReturn: "" + CSR + "|22.00"
        },
        {
            cName: "" + DOR + "",
            cReturn: "" + DOR + "|27.00"
        },
        {
            cName: "" + CRR + "",
            cReturn: "" + CRR + "|27.00"
        },
        {
            cName: "" + HOR + "",
            cReturn: "" + HOR + "|27.00"
        },
        {
            cName: "" + MJR + "",
            cReturn: "" + MJR + "|27.00"
        },
        {
            cName: "" + VIR + "",
            cReturn: "" + VIR + "|27.00"
        },
        {
            cName: "" + SDR + "",
            cReturn: "" + SDR + "|27.00"
        },
        {
            cName: "" + ASR + "",
            cReturn: "" + ASR + "|27.00"
        }
    ]
    //(count 8)
}, {
    cName: "Family / Kids",
    oSubMenu: [{
            cName: "" + SCR + "",
            cReturn: "" + SCR + "|22.00"
        },
        {
            cName: "" + CAR + "",
            cReturn: "" + CAR + "|27.00"
        },
        {
            cName: "" + FJR + "",
            cReturn: "" + FJR + "|27.00"
        },
        {
            cName: "" + FUR + "",
            cReturn: "" + FUR + "|27.00"
        },
        {
            cName: "" + CHR + "",
            cReturn: "" + CHR + "|22.00"
        },
        {
            cName: "" + KKR + "",
            cReturn: "" + KKR + "|27.00"
        },
        {
            cName: "" + KDR + "",
            cReturn: "" + KDR + "|27.00"
        },
        {
            cName: "" + LKR + "",
            cReturn: "" + LKR + "|27.00"
        },
        {
            cName: "" + PMR + "",
            cReturn: "" + PMR + "|27.00"
        }
    ]
    //(count 9)
}, {
    cName: "American Heroes",
    oSubMenu: [{
            cName: "" + AFR + "",
            cReturn: "" + AFR + "|17.00"
        },
        {
            cName: "" + AYR + "",
            cReturn: "" + AYR + "|17.00"
        },
        {
            cName: "" + GUR + "",
            cReturn: "" + GUR + "|17.00"
        },
        {
            cName: "" + UAR + "",
            cReturn: "" + UAR + "|17.00"
        },
        {
            cName: "" + NAR + "",
            cReturn: "" + NAR + "|17.00"
        },
        {
            cName: "" + UPR + "",
            cReturn: "" + UPR + "|22.00|2"
        },
        {
            cName: "-"
        },
        {
            cName: "" + TSR + "",
            cReturn: "" + TSR + "|27.00"
        },
        {
            cName: "" + OFR + "",
            cReturn: "" + OFR + "|27.00"
        },
        {
            cName: "" + PBR + "",
            cReturn: "" + PBR + "|22.00"
        },
        {
            cName: "" + SFR + "",
            cReturn: "" + SFR + "|22.00"
        },
        {
            cName: "" + WER + "",
            cReturn: "" + WER + "|27.00"
        },
        {
            cName: "" + VTR + "",
            cReturn: "" + VTR + "|17.00"
        }
    ]
    //(count 10)
}, {
    cName: "Professional Sports",
    oSubMenu: [{
            cName: "" + MAR + "",
            cReturn: "" + MAR + "|27.00"
        },
        {
            cName: "" + PTR + "",
            cReturn: "" + PTR + "|27.00"
        },
        {
            cName: "" + JJR + "",
            cReturn: "" + JJR + "|27.00"
        },
        {
            cName: "" + MDR + "",
            cReturn: "" + MDR + "|27.00"
        },
        {
            cName: "" + MHR + "",
            cReturn: "" + MHR + "|27.00"
        },
        {
            cName: "" + OMR + "",
            cReturn: "" + OMR + "|27.00"
        },
        {
            cName: "" + BBR + "",
            cReturn: "" + BBR + "|27.00"
        },
        {
            cName: "" + DRR + "",
            cReturn: "" + DRR + "|27.00"
        },
        {
            cName: "" + TBR + "",
            cReturn: "" + TBR + "|27.00"
        },
        {
            cName: "" + NZR + "",
            cReturn: "" + NZR + "|27.00"
        }
    ]
    //(count 10)
}, {
    cName: "Collegiate",
    oSubMenu: [{
            cName: "" + BYR + "",
            cReturn: "" + BYR + "|27.00"
        },
        {
            cName: "" + BCR + "",
            cReturn: "" + BCR + "|27.00"
        },
        {
            cName: "" + CCR + "",
            cReturn: "" + CCR + "|27.00"
        },
        {
            cName: "" + ECR + "",
            cReturn: "" + ECR + "|27.00"
        },
        {
            cName: "" + EWR + "",
            cReturn: "" + EWR + "|27.00"
        },
        {
            cName: "" + EAR + "",
            cReturn: "" + EAR + "|27.00"
        },
        {
            cName: "" + FXR + "",
            cReturn: "" + FXR + "|27.00"
        },
        {
            cName: "" + FMR + "",
            cReturn: "" + FMR + "|27.00"
        },
        {
            cName: "-"
        },
        {
            cName: "" + FAR + "",
            cReturn: "" + FAR + "|27.00"
        },
        {
            cName: "" + FRR + "",
            cReturn: "" + FRR + "|27.00"
        },
        {
            cName: "" + FGR + "",
            cReturn: "" + FGR + "|27.00"
        },
        {
            cName: "" + FHR + "",
            cReturn: "" + FHR + "|27.00"
        },
        {
            cName: "" + FTR + "",
            cReturn: "" + FTR + "|27.00"
        },
        {
            cName: "" + FIR + "",
            cReturn: "" + FIR + "|27.00"
        },
        {
            cName: "" + FER + "",
            cReturn: "" + FER + "|27.00"
        },
        {
            cName: "" + FZR + "",
            cReturn: "" + FZR + "|27.00"
        },
        {
            cName: "-"
        },
        {
            cName: "" + FSR + "",
            cReturn: "" + FSR + "|27.00"
        },
        {
            cName: "" + JUR + "",
            cReturn: "" + JUR + "|27.00"
        },
        //{cName:""+KUR+"",cReturn:""+KUR+"|27.00"},
        {
            cName: "" + LUR + "",
            cReturn: "" + LUR + "|27.00"
        },
        {
            cName: "" + NWR + "",
            cReturn: "" + NWR + "|27.00"
        },
        {
            cName: "" + NSR + "",
            cReturn: "" + NSR + "|27.00"
        },
        {
            cName: "" + PUR + "",
            cReturn: "" + PUR + "|27.00"
        },
        {
            cName: "" + RAR + "",
            cReturn: "" + RAR + "|27.00"
        },
        {
            cName: "" + RLR + "",
            cReturn: "" + RLR + "|27.00"
        },
        {
            cName: "-"
        },
        {
            cName: "" + SLR + "",
            cReturn: "" + SLR + "|27.00"
        },
        {
            cName: "" + SXR + "",
            cReturn: "" + SXR + "|27.00"
        },
        {
            cName: "" + SER + "",
            cReturn: "" + SER + "|27.00"
        },
        {
            cName: "" + SUR + "",
            cReturn: "" + SUR + "|27.00"
        },
        {
            cName: "" + UCR + "",
            cReturn: "" + UCR + "|27.00"
        },
        {
            cName: "" + UFR + "",
            cReturn: "" + UFR + "|27.00"
        },
        {
            cName: "" + UMR + "",
            cReturn: "" + UMR + "|27.00"
        },
        {
            cName: "" + UNR + "",
            cReturn: "" + UNR + "|27.00"
        },
        {
            cName: "-"
        },
        {
            cName: "" + USR + "",
            cReturn: "" + USR + "|27.00"
        },
        {
            cName: "" + UTR + "",
            cReturn: "" + UTR + "|27.00"
        },
        {
            cName: "" + UWR + "",
            cReturn: "" + UWR + "|27.00"
        },
        {
            cName: "" + WSR + "",
            cReturn: "" + WSR + "|27.00"
        }
    ]
    //(count 36)
}, {
    cName: "Motorcyle",
    oSubMenu: [{
            cName: "" + MYR + "",
            cReturn: "" + MYR + "|19.00"
        },
        {
            cName: "" + MUR + "",
            cReturn: "" + MUR + "|19.00"
        }
    ]
    //(count 2)
    //total plate count 121
}];

module.exports = specialityPlates;



// WEBPACK FOOTER //
// ./src/modules/data/specialty-plates.js